import { Listbox as HeadlessListbox } from "@headlessui/react";
import React from "react";
import { joinClasses } from "../../utils/joinClasses";
export const Listbox = ({ className, ...props }) => (React.createElement(HeadlessListbox, { as: "div", className: joinClasses(["nxm-dropdown", className]), ...props }));
